import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors, tint } from '../../../../../ai-suite/theme';

/**
 * A drill's goal, in one line under the top bar; `plain` shows the line
 * alone (a moment replay's banner).
 */
export const DrillGoal = memo(
  ({ goal, plain }: { goal: string; plain?: boolean }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          paddingHorizontal: rpx(16),
          paddingVertical: rpx(8),
          backgroundColor: tint(aiColors.violet, 0.08),
        }}
      >
        <Typography.Text
          size={rpx(13)}
          color={aiColors.violet}
          numberOfLines={1}
        >
          {plain ? goal : `专项小练 · ${goal}`}
        </Typography.Text>
      </View>
    );
  },
);
